import errors from './errors/index.js';
import translation from './translation/index.js';
const pl_pl = {
    translation,
    errors,
};
export default Object.freeze(pl_pl);
